export const GET_MY_FILES_REQUEST = 'GET_MY_FILES_REQUEST';
export const GET_MY_FILES_FAILURE = 'GET_MY_FILES_FAILURE';
export const GET_MY_FILES_SUCCESS = 'GET_MY_FILES_SUCCESS';

export const GET_COMPANY_FILES_REQUEST = 'GET_COMPANY_FILES_REQUEST';
export const GET_COMPANY_FILES_FAILURE = 'GET_COMPANY_FILES_FAILURE';
export const GET_COMPANY_FILES_SUCCESS = 'GET_COMPANY_FILES_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/filebox/mutation-types.js